import { defineMessages } from 'react-intl';

export default defineMessages({
  jiraIssues: {
    id: 'frontbucket.jiraPage.jiraIssues',
    description: 'Header of jira page',
    defaultMessage: 'Jira issues',
  },
  errorPageMessage: {
    id: 'frontbucket.jiraPage.errorPageMessage',
    description: 'Message for error loading page',
    defaultMessage: `We can't load the page`,
  },
});
